import React from 'react';
import ExtractInvoiceForm from '../../../features/Financial/ExtractInvoiceForm';
const ExtractInvoices = () => {
  return (<ExtractInvoiceForm />
  )
}
export default ExtractInvoices;